import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Config from './Config.js';

class ForgetPassword extends Component {

  constructor(props){
    super(props);

    this.state = {
      username : '',
      referenceCode : '',
      otpCode : '',
      next: '',
      token: ''
    }

    this.send = this.send.bind(this);
    this.confirm = this.confirm.bind(this);
  }

  send(){

    let url = Config.SERVER_URL + Config.API_FORGET_PASSWORD +'?phoneNumOrEmail=' + this.state.username;

    fetch(url, {
       method: 'POST',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
       },
    })
    .then((response) =>     response.json())
    .then((responseJson) => {

      if(responseJson.Result){

        this.setState({referenceCode : responseJson.ReferenceCode});
      }else if(responseJson.Result === undefined){
        alert(responseJson.Message);
      }else{

        alert(responseJson.ResultMessage);
      }

    })
    .catch((error) => {

    });

  }

  confirm(){
    let url = Config.SERVER_URL + Config.API_OTP_VERIFY +'?ReferenceID='+this.state.referenceCode+'&OTP='+this.state.otpCode;

    fetch(url, {
       method: 'POST',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
       },
    })
    .then((response) =>     response.json())
    .then((responseJson) => {
      if(responseJson.Result){
        this.setState({
          next : 'forgetPasswordChangePW',
          token : responseJson.token
        });
      }else{
        alert(responseJson.ResultMessage);
      }
    })
    .catch((error) => {

    });
  }

  render() {

    if(this.state.next === 'forgetPasswordChangePW'){
      return <Redirect to={{
        pathname: '/forgetPasswordChangePW',
        token: this.state.token}}
      />;
    }

    return(

      <div className='container' style={{backgroundColor: 'rgb(220, 224, 239)'}}>

        <div style={{height:80}} />

        <div className="row">
          <div className="col-md-4 col-md-offset-4" style={{ backgroundColor: 'rgb(208 ,211 ,229)' , textAlign:'center' , borderRadius: 5,paddingLeft: 0 , paddingRight:0 }}>
            <div style={{height:20}}/>

            <div style={{ paddingTop: 10,marginLeft: 33,backgroundColor: 'rgb(68 ,53 ,109)',
              width:315 ,height:49 , borderRadius: 5}}>
                <h6 style={{color: 'white'}}>FORGET PASSWORD</h6>
            </div>

            <div style={{height:21}} />

            <input type='text' placeholder="Email/ Telephone number"
              style={{borderRadius:4 ,width:314 ,height:37
                ,paddingLeft: 10, paddingRight:10 ,
                backgroundColor:'rgb(236 ,240 ,241)'}}
              value={this.state.username}
              onChange={(event) => { this.setState({username :event.target.value })}}
              />

            <div style={{height:17}}/>

            <div>
              <div style={{ width: 250 ,display:'inline-block'}}>
                <h6>{"Please fill your telephone number or E-mail with register for genode"}</h6>
              </div>
              <div style={{display:'inline-block', verticalAlign: 'top'}}>

                <button onClick={this.send}
                  style={{verticalAlign: 'top' ,textAlign:'center',height: 29,width:56, borderRadius: 4,color: 'white',
                    background: "linear-gradient(#41b9ce, #58488b)"}}>SEND
                </button>
              </div>

            </div>

            <div style={{height:44}}/>

            <div style={{marginLeft: 43,textAlign:'left' ,height:14}}>
              OTP Code
            </div>

            <div style={{height: 8}}/>

            <div>
              <input type='text' placeholder="12345"
                style={{borderRadius:4 ,width:86 ,height:30
                  ,paddingLeft: 10, paddingRight:10 ,
                  verticalAlign: 'top', marginLeft: 20,
                  backgroundColor:'rgb(236 ,240 ,241)'}}
                value={this.state.otpCode}
                maxLength="5"
                onChange={(event) => { this.setState({otpCode :event.target.value })}}
                />
              <div style={{display:'inline-block' ,marginLeft: 3,width: 220 }}>
                <h6>{"Please fill your OTP which you receive from SMS or E-mail"}</h6>
              </div>
            </div>

            <div style={{height:35}}/>

            <button onClick={this.confirm}
              style={{verticalAlign: 'top',height: 29,width:89, borderRadius: 4,color: 'white',background: "linear-gradient(#41b9ce, #58488b)"}}>
              CONFIRM
            </button>

            <div style={{height:20}} />

          </div>
        </div>

      </div>
    );
  }
}

export default ForgetPassword;



// WEBPACK FOOTER //
// ./src/components/ForgetPassword.js